import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelectedMenu,
  setSelectedMenuId,
  selectHasNativeHRIS,
} from "../../redux/features/appData/appDataSlice";
import Modal from "../shared/Modal";
import "./ModalHRISRequired.css";
import { Button } from "../../ds2/components";

type ModalHRISRequiredProps = {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
};

const ModalHRISRequired = ({
  isOpen,
  onClose,
  onContinue,
}: ModalHRISRequiredProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const hasNativeHRIS = useSelector(selectHasNativeHRIS);

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        style={null}
        onClose={onClose}
        canClose={false}
        allowClickout={true}>
        <div id="modal-hris-required">
          <div className="modal-hris-required-title">HRIS Required</div>

          <div className="modal-hris-required-content">
            <p>
              {hasNativeHRIS
                ? "This workspace uses native HRIS for employee data management. The required HRIS functionality should be available."
                : "This requires an HRIS to be connected to your workspace."}
            </p>
          </div>

          <div className="modal-hris-required-footer">
            <div className="modal-hris-required-buttons">
              <Button variant="secondary" onClick={onClose}>
                Cancel
              </Button>
              {!hasNativeHRIS && (
                <Button
                  onClick={() => {
                    navigate("/waz/settings/workspaces?tab=4");
                    dispatch(setSelectedMenu(null));
                    dispatch(setSelectedMenuId(null));
                  }}>
                  Connect
                </Button>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalHRISRequired;
